export class UserAgentUtil {
  public static isAndroid(): boolean {
    if (navigator.userAgent.match(/Android/i)) {
      return true;
    }

    return false;
  }
}
